import { useLocation } from "react-router-dom";

const useHideMenu = () => {
  const location = useLocation();
  return location.pathname === "/shop/stripe/checkout";
};

export { useHideMenu };
